import Resource from './Resource';

export default class Payments extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {},
		} = options;

		let config = {
			route: "payments/:service/:action",
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	post(){
		return this.request('post');
	}
	get(){
		return this.request('get');
	}
}
